import styled from "@emotion/styled";
import { ListItem as MuiListItem } from "@mui/material";

const ListItem = styled(MuiListItem)({
  padding: "15px 0px 15px 0px !important",
  margin: 0,
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: "1px solid #e0e0e0",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
});

export default ListItem;